function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children"],
  _excluded2 = ["variant", "children", "onOpen", "onClose", "duration", "isActive", "isMountOnOpen", "isUnmountOnClose", "onContainerSize", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { StyledAnimate, StyledAnimateComponent } from './animate.styles';
import Box from '../box';
import ContainerQuery from '../container-query';
var animatePropTypes = {
  /** Specifies the animation style. */
  variant: PropTypes.oneOf(['slideRight', 'slideBottom', 'fade', 'expand']),
  /** Provide the component to be animated as a child. Must be a valid element (HTML/React) */
  children: PropTypes.element,
  /** A callback function which is called after the Animation has ended. */
  onClose: PropTypes.func,
  /** A callback function which is called after the Animation has began. */
  onOpen: PropTypes.func,
  /** Animation Duration in ms */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  /** Toggle the Animation */
  isActive: PropTypes.bool,
  /** Mount the component onOpen */
  isMountOnOpen: PropTypes.bool,
  /** Unmount the component onClose */
  isUnmountOnClose: PropTypes.bool,
  /** Callback function for when the size of the component changes. */
  onContainerSize: PropTypes.func,
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var animateDefaultProps = {
  variant: 'fade',
  children: /*#__PURE__*/React.createElement(Box, {
    variant: "dark"
  }),
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  duration: 300,
  isActive: false,
  isMountOnOpen: true,
  isUnmountOnClose: true,
  onContainerSize: function onContainerSize() {},
  utils: {}
};
var AnimateChild = StyledAnimateComponent(function () {
  var child = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
    var children = _ref.children,
      other = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      ref: forwardedRef
    }, /*#__PURE__*/React.cloneElement(children, _objectSpread({}, other)));
  });
  child.propTypes = {
    children: PropTypes.node
  };
  child.defaultProps = {
    children: /*#__PURE__*/React.createElement(React.Fragment, null)
  };
  child.displayName = 'AnimateChild';
  return child;
}());
var calcHeight = function calcHeight(isHtmlElement, node, variant, setChildHeight) {
  if (variant == 'expand') {
    setChildHeight(isHtmlElement ? node.firstChild.clientHeight : node.lastChild.clientHeight);
  }
};

/**
 * @ignore @description
 * ## Animate Component
 * Wrap your components in the Animate component to add animation.
 *
 * @ignore @see Mesh: [Animate Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/base-animate--default)
 *
 * @ignore @example
 * ```jsx
 * import { Animate } from 'mesh-component-library';
 *
 * <Animate {...props}>
 *  {children}
 * </Animate>
 * ```
 */

var Animate = function Animate(props) {
  var variant = props.variant,
    children = props.children,
    onOpen = props.onOpen,
    onClose = props.onClose,
    duration = props.duration,
    isActive = props.isActive,
    isMountOnOpen = props.isMountOnOpen,
    isUnmountOnClose = props.isUnmountOnClose,
    onContainerSize = props.onContainerSize,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded2);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    childHeight = _useState2[0],
    setChildHeight = _useState2[1];
  var isHtmlElement = /*#__PURE__*/React.isValidElement(children) && typeof children.type === 'string';
  return /*#__PURE__*/React.createElement(Transition, _extends({
    "in": isActive,
    timeout: duration,
    onExited: onClose,
    onEntering: function onEntering(node, isAppearing) {
      calcHeight(isHtmlElement, node, variant, setChildHeight);
      onOpen(node, isAppearing);
    },
    onExiting: function onExiting(node) {
      calcHeight(isHtmlElement, node, variant, setChildHeight);
    },
    mountOnEnter: isMountOnOpen,
    unmountOnExit: isUnmountOnClose
  }, other), function (animationState) {
    return !isHtmlElement && variant !== 'expand' ? /*#__PURE__*/React.createElement(ContainerQuery, {
      onContainerSize: onContainerSize
    }, /*#__PURE__*/React.createElement(AnimateChild, {
      duration: duration,
      animation: variant,
      animationState: animationState,
      childHeight: childHeight,
      isActive: isActive,
      utils: utils
    }, children)) : /*#__PURE__*/React.createElement(ContainerQuery, {
      onContainerSize: onContainerSize
    }, /*#__PURE__*/React.createElement(StyledAnimate, _extends({
      duration: duration,
      animation: variant,
      animationState: animationState,
      childHeight: childHeight,
      isActive: isActive,
      utils: utils
    }, other), children));
  });
};
Animate.propTypes = animatePropTypes;
Animate.defaultProps = animateDefaultProps;
Animate.calcHeight = calcHeight;
export default Animate;